// @flow

import ApiObject from './ApiObject';

export default class CRMSettings extends ApiObject {
  /**
  * Set to true if there is a CRM attached.
  * Set to false if there is no CRM attached, or if it's disable.
  */
  enabled: boolean = false

  /**
  * The crm type
  */
  crmType: string;

  /**
  * The url to use for development purpose.
  */
  serverUrl: string;

  static CRMType = {
    NEOLANE_HIPPO: 'NEOLANE_HIPPO'
  };
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/CRMSettings.js